export default "__VITE_ASSET__CuD308sl__"